import Vue from 'vue'
import Router from 'vue-router'
import constant from '../utils/constant'

import HomeIndex from '@/containers/Home/Index'
import LoginIndex from '@/containers/Login/Index'
import WhitelistIndex from '@/containers/Whitelist/Index'
import UserPermissionIndex from '@/containers/UserPermission/Index'
import SystemConfigIndex from '@/containers/SystemConfig/Index'

import PgApiDetail from '@/components/PgApiDetail'

Vue.use(Router)

// 路由
// LoginIndex登录页
// HomeIndex主页
//   ->  WhitelistIndex白名单
//   ->  UserPermissionIndex用户权限
//   ->  SystemConfig系统配置

// 路由前置名
const pathPre = constant.pathPre

const routers = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: pathPre + '/Home/Index'
    },
    {
      path: pathPre + '/Login/Index',
      name: 'LoginIndex',
      component: LoginIndex
    }, {
      path: pathPre + '/Home/Index',
      name: 'HomeIndex',
      component: HomeIndex,
      children: [{
        path: pathPre + '/api/active/apiDetail/:id',
        component: PgApiDetail
      }, {
        path: pathPre + '/api/active/function/userRole',
        component: UserPermissionIndex
      }, {
        path: pathPre + '/api/active/function/system',
        component: SystemConfigIndex
      }, {
        path: pathPre + '/api/active/function/ipAddress',
        component: WhitelistIndex
      }]
    }
    // {
    //   path: '*',
    //   redirect: 'dayee/Login/Index',
    //   name: 'notFound',
    //   hidden: true
    // }
  ]
})

routers.beforeEach((to, from, next) => {
  if (to.hash) {
    next(false)
    return false
  }
  next()
})

export default routers



// WEBPACK FOOTER //
// ./src/router/index.js